<template>
  <div>
    <div class="page-title">Ethics & Malpractice Statement</div>
    <ethics-and-malpractice-content></ethics-and-malpractice-content>
  </div>
</template>

<script>
  import EthicsAndMalpracticeContent from '@/components/about/EthicsAndMalpracticeComponent'
  export default {
    components: {
      EthicsAndMalpracticeContent
    },
    name: 'ethics-and-malpractice',
    data () {
      return {
      }
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// EthicsAndMalpracticePage.vue?2ec038ba